import CoreBase from '../../../services/engines/CoreBase';
import { PV_PIN_KEY } from './plugVueConst';

// Device-local pinned plug rk's (localStorage)
class PlugPinStore extends CoreBase {
    _name = 'PlugPinStore';
    _pins = null;

    /**
     * @param {string} rk
     * @returns {boolean}
     */
    has = (rk) => this._load().has(rk);

    /**
     * @param {string} rk
     * @returns {boolean} new pinned state
     */
    toggle = (rk) => {
        const pins = this._load();
        if (pins.has(rk)) pins.delete(rk);
        else pins.add(rk);
        this._save();
        return pins.has(rk);
    };

    _load = () => {
        if (this._pins) return this._pins;
        try {
            const raw = localStorage.getItem(PV_PIN_KEY);
            this._pins = new Set(raw ? JSON.parse(raw) : []);
        } catch (error) {
            this.logError('_load', error.message);
            this._pins = new Set();
        }
        return this._pins;
    };

    _save = () => {
        try {
            localStorage.setItem(PV_PIN_KEY, JSON.stringify([...this._pins]));
        } catch (error) {
            this.logError('_save', error.message);
        }
    };
}

const plugPinStore = new PlugPinStore();
export default plugPinStore;
